import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate ,useSearchParams } from 'react-router-dom';
import URL from '../constants/ServerUrl';
const categoryOptions = [
  { value: 'KGFAT + KGSNF', label: 'KGFAT + KGSNF' },
  { value: 'KG FAT ONLY', label: 'KG FAT ONLY' },
];

const levelOptions = [
  { value: 1, label: 'Level 1' },
  { value: 2, label: 'Level 2' },
  { value: 3, label: 'Level 3' },
  { value: 4, label: 'Level 4' },
];

const AddRateChart = () => {
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const [category, setCategory] = useState('KGFAT + KGSNF');
  const [level, setLevel] = useState(null);
  const [rateChartName, setRateChartName] = useState('');
  const [stdFatRate, setStdFatRate] = useState('');
  const [stdSNFRate, setStdSNFRate] = useState('');
  const [stdTSRate, setStdTSRate] = useState('');
  const [incentive, setIncentive] = useState('');
  const navigator=useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("dairy-token")


  const addRateChart = async () => {
    try {
      if (username) {
        setIsLoading(true);
        const res = await axios.post(`${URL}admin/${username}/ratelist`, {
          category,
          level,
          rateChartName,
          stdFatRate,
          stdSNFRate,
          stdTSRate,
          incentive,
        },{
          Authorization: `Bearer ${token}`,
        });
        setCategory('KGFAT + KGSNF');
        setLevel(null);
        setRateChartName('');
        setStdFatRate('');
        setStdSNFRate('');
        setStdTSRate('');
        setIsLoading(false);
        alert('Rate Chart Saved Successfully');
      }
      navigator(-1);
    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        console.log(error.response.data);
        alert(error.response.data);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error:', error.message);
      }
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-gray-100">
      <div className="max-w-md w-full">
        <label htmlFor="category" className="block mb-2">
          ENTER CATEGORY
        </label>
        <select
          id="category"
        
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="block w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
        >
          {categoryOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <label htmlFor="level" className="block mt-3 mb-2">
          ENTER LEVEL
        </label>
        <select
          id="level"
          value={level}
          onChange={(e) => setLevel(e.target.value)}
          className="block w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
        >
          <option value="">Select Level</option>
          {levelOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <input
          type="text"
          value={rateChartName}
          onChange={(e) => setRateChartName(e.target.value)}
          placeholder="ENTER RATE CHART NAME"
          className="block w-full p-2 mt-3 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
        />

        {['KGFAT + KGSNF', 'KG FAT ONLY'].includes(category) && (
          <input
            type="text"
            value={stdFatRate}
            onChange={(e) => setStdFatRate(e.target.value)}
            placeholder="ENTER STANDARD FAT RATE"
            className="block w-full p-2 mt-3 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
          />
        )}

        {category === 'KGFAT + KGSNF' && (
          <div>
            <input
              type="text"
              value={stdSNFRate}
              onChange={(e) => setStdSNFRate(e.target.value)}
              placeholder="ENTER STANDARD SNF RATE"
              className="block w-full p-2 mt-3 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
            />
            <input
              type="text"
              value={stdTSRate}
              onChange={(e) => setStdTSRate(e.target.value)}
              placeholder="ENTER TS RATE"
              className="block w-full p-2 mt-3 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
            />
          </div>
        )}

        <input
          type="text"
          value={incentive}
          onChange={(e) => setIncentive(e.target.value)}
          placeholder="ENTER INCENTIVE"
          className="block w-full p-2 mt-3 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
        />

        <button
          onClick={addRateChart}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
          disabled={isLoading}
        >
          
          {isLoading ? 'Saving...' : 'Save'}
        </button>
      </div>
    </div>
  );
};

export default AddRateChart;
